import React, {Component} from 'react';
import {Modal, ModalBody, ModalHeader} from "reactstrap";
import {request} from "../../util/APIUtils";
import Table from "../../components/Table/Table";
import DetailedSearch from "../../components/DetailedSearch/DetailedSearch";
import {deepCopyObject, filterCities, showAxiosError, trimObject} from "../../util/Helpers";
import {API_BASE_URL} from "../../constants";
import './ChangeRequestList.css';
import MemberGeneralInfo from "../memberList/MemberGeneralInfo";
import Alert from "react-s-alert";
import moment from "moment";

class ChangeRequestList extends Component {

    constructor(props) {
        super(props);

        this.state = {
            selectedChangeRequest: null,
            branches: [],
            cities: [],
            changeRequests: [],
            changeRequest: null,
            loading: false,
            searching: false,
            searchQuery: undefined,
            total: 0,
            page: 0,
            size: 10,
            manual: false,
            addChangeRequestModal: false,
        };

        this.handleSearch = this.handleSearch.bind(this);
        this.listChangeRequests = this.listChangeRequests.bind(this);
        this.cancel = this.cancel.bind(this);
        this.listCities = this.listCities.bind(this);
        this.listBranches = this.listBranches.bind(this);
    }

    componentDidMount(){

        this.listBranches();
        this.listCities();

    }

    listBranches() {
        let self = this;
        let params = {
            url: API_BASE_URL+"/oda/oda-list/" ,
            method: "get",
        };
        request(params)
            .then(function (response) {
                let branches = response.data;
                self.setState({
                    branches,
                });
            }).catch(function (error) {
            showAxiosError(error);
        });
    }

    listCities() {
        let self = this;
        let params = {
            url: API_BASE_URL+"/city/" ,
            method: "get",
        };
        request(params)
            .then(function (response) {
                let cities = response.data;
                let cityList=(self.props.currentUser.realm===0) ? filterCities(cities,1000) : filterCities(cities,self.props.currentUser.realm);
                self.setState({
                    cities:cityList,
                });
            }).catch(function (error) {
            showAxiosError(error);
        });
    }


    cancel() {
        let self=this;
        self.setState({
            addChangeRequestModal: false,
            selectedChangeRequest: null,
        })
    }

    listChangeRequests(accessor, direction, page, size) {
        let self = this;
        let sortStr = !!accessor ? ('&sort=' + accessor + ',' + direction) : '&sort=id,asc';
        let searchQuery = !self.state.searchQuery ? '' : '&' + self.state.searchQuery;
        let params = {
            url: API_BASE_URL+'/change-request/fetch?page=' + page + '&size=' + size + sortStr + searchQuery,
            method: "get",
        };
        self.setState({loading: true, manual: self.manual === true ? false : self.manual, searching: true});
        request(params)
            .then(function (response) {
                let changeRequests = response.data.content;
                self.setState({
                    page: page,
                    size: size,
                    total: response.data.totalElements,
                    changeRequests,
                    loading: false,
                    searching: false
                });
            }).catch(function (error) {
            self.setState({loading: false, searching: false});
            showAxiosError(error);
        });
    }

    handleEdit(item) {
        let self = this;
        let mode;

        self.state.searchQuery
            ?
            self.state.searchQuery.toString().includes("NOT_PROCESSED")
                ?
                mode = 'review'
                :
                self.state.searchQuery.toString().includes("APPROVED") ?  mode = 'review_approved' :  mode = 'review_not_approved'
            :
            mode = 'review';

        self.setState({
            mode: mode,
            changeRequest: item,
            addChangeRequestModal: true
        });
    }

    save(){
        let self = this;
        let params;
        let data;
        let message;
        // let validity = this.validateComponent();
        let changeRequest = deepCopyObject(this.state.changeRequest);
        let member = deepCopyObject(this.state.memberInfo);
        //let hasPhotoFile = ( changeRequest.fotoThumbFile === null || changeRequest.fotoThumbFile === "") ? false : true ;

        //if (validity.valid && hasPhotoFile) {
        changeRequest = trimObject(changeRequest);
        let finalRequest = this.filterChangedFields( deepCopyObject(changeRequest), deepCopyObject(member));
        if (!this.isEmtpyRequest(finalRequest)) {
            self.setState({isLoading: true});
            finalRequest["cityId"] = member.city.id;
            finalRequest["memberId"] = member.id;
            finalRequest["isActive"] = true;
            data = finalRequest;
            console.log("data", data);
            message = 'Değişiklik Talebi Başarıyla Kaydedildi.'
            params = {
                url: API_BASE_URL + "/change-request/ddddd",
                data: data,
                method: 'post'
            };

            request(params).then((response) => {
                Alert.success(
                    message, {
                        position: 'top-right',
                        effect: 'stackslide',
                        timeout: 5000
                    });
                self.setState({pendingRequest: response.data, hasPendingRequest:true , isLoading: false});
            }).catch(function (error) {
                self.setState({isLoading: false});
                showAxiosError(error);
            });
        }else{
            Alert.error(
                "Hiç Bir Değişiklik Yapmadınız!", {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 10000
                });
        }
        /*  }else{
              let msg= "Hatalı Alanları Düzeltiniz!";
              if(!hasPhotoFile){
                  msg=msg + "</br> Fotoğraf Yükleyiniz!";
              }
              Alert.error(
                  msg, {
                      position: 'top-right',
                      effect: 'stackslide',
                      timeout: 10000
                  });
          }*/
    }

    handleSearch(searchQuery) {
        let self = this;
        self.setState({
            searchQuery,
            searching: true
        }, () => self.listChangeRequests(self.state.accessor, self.state.direction, self.state.page, self.state.size))
    }

    getStatusText(status){
        return (status==="NOT_PROCESSED") ? " Onay Bekliyor" : (status==="APPROVED") ? " Onaylandı" : "Reddedildi" ;
    }

    render() {
        let branchSelectdata;
        let citySelectdata;
        const {changeRequests} = this.state;
        const {branches} = this.state;
        const {cities} = this.state;
        const activationState=[
            //{value: null, label: "Tümü"},
            {value: 'NOT_PROCESSED', label: "Onay Bekleyenler"},
            {value: 'APPROVED', label: "Onaylananlar"},
            {value: 'DENIED', label: "Reddedilenler"},
        ];
        const header=[
            {value: null, label: "Tümü"},
        ];
        branches ? branchSelectdata = header.concat(branches) :  branchSelectdata = header ;
        cities ? citySelectdata = header.concat(cities) :  citySelectdata = header ;

        console.log("changeRequests",changeRequests);
        const columns = [
            {
                Header: "Ad",
                accessor: "member.ad",
                Cell: item => ( <label>{item.member.ad}</label> )
            },
            {
                Header: "Soyad",
                accessor: "member.soyad",
                Cell: item => ( <label>{item.member.soyad}</label> )
            },
            {
                Header: "TC Kimlik No",
                accessor: "member.tcKimlikNo",
                Cell: item => ( <label>{item.member.tcKimlikNo}</label> )
            },
            {
                Header: "Sicil No",
                accessor: "member.odaSicilNo",
                Cell: item => ( <label>{item.member.odaSicilNo}</label> )
            },
            {
                Header: "Tarih",
                accessor: "item.creationDate",
                Cell: item => ( <label>{item.creationDate && moment(item.creationDate).format("DD.MM.YYYY")}</label> )

            },
            {
                Header: "İl",
                accessor: "city.ad",
                Cell: item => ( <label>{item.city.ad}</label> )

            },
            {
                Header: "Durum",
                accessor: "processState",
                Cell: item => ( <label>{item.processState && this.getStatusText(item.processState)}</label> )

            },
            {
                Header: "Oda",
                accessor: "city.oda.ad",
                Cell: item => (  <label>{item.city.oda && item.city.oda.ad.toString().substring(0,25)+"..." }</label> )

            },
            {
                Header: "İşlemler",
                accessor: "",
                sortable: false,
                Cell: item => (
                    <div>
                        <button type="button"
                                onClick={() => this.handleEdit(item)}
                                data-toggle="tooltip" data-placement="bottom" title="Düzenle"
                                style={{background: 'linear-gradient(rgb(120, 177, 215), rgb(120, 177, 215))'}}
                                rel="tooltip" className="Btn btn-sm btn-icon">
                            <i className="fa fa-edit"/>
                        </button>
                    </div>
                )
            }
        ];

        const fields = [
            {
                label: "İşlem Durumu",
                accessor: "processState",
                type: "select",
                operator: "=",
                selectData: activationState,
            },
            {
                label: "İl",
                accessor: "city.id",
                type: "select",
                operator: "=",
                selectData: citySelectdata,
            },
            {
                label: "Ad",
                accessor: "member.ad",
                type: "text",
                operator: "=",
            },
            {
                label: "Soyad",
                accessor: "member.soyad",
                type: "text",
                operator: "=",
            },
            {
                label: "TC Kimlik No",
                accessor: "member.tcKimlikNo",
                type: "text",
                operator: "=",
            },
            {
                label: "Oda",
                accessor: "city.oda.id",
                type: "select",
                operator: "=",
                selectData: branchSelectdata,
            },


        ];
        return (

            <div className="odaList-container">
                <div className="row baseBackground">
                    <div className="col-md-12 satirBasi">
                        <div className="card-header ">
                            <h4 className="card-title">Üye İstek Ve Talepleri
                                {this.state.searchQuery
                                    ?
                                    this.state.searchQuery.toString().includes("NOT_PROCESSED")
                                        ?
                                        " (ONAY BEKLEYENLER)"
                                        :
                                        this.state.searchQuery.toString().includes("APPROVED") ? " (ONAYLANANLAR) " : " (REDDEDİLENLER)"
                                    :
                                    " (ONAY BEKLEYENLER)"
                                }

                            </h4>
                        </div>
                        <div className="card-body mt-1">
                            <div className=" ">
                                <div className="" style={{marginTop: '10px', marginBottom: '10px'}}>
                                    <DetailedSearch fields={fields}
                                                    loading={this.state.searching}
                                                    onSearch={this.handleSearch}/>
                                </div>
                            </div>
                        </div>
                        <div className="card-body">
                            <Table
                                loading={this.state.loading}
                                loadingText="Kayıtlar getiriliyor..."
                                content={changeRequests}
                                total={this.state.total}
                                page={this.state.page}
                                manual={this.state.manual}
                                size={this.state.size}
                                options={["5", "10", "20", "50", "100"]}
                                columns={columns}
                                fetchData={this.listChangeRequests}
                                style={{width:"100%"}}
                            />
                        </div>
                    </div>
                    {/* {
                    (RightExists("ROLE_RIGHT_CHAMBER_CREATE",this.props.authorities))
                    &&
                    <div className="new-button-holder">
                        <button type="button"
                                onClick={() => this.addNew()}
                                data-toggle="tooltip" data-placement="bottom" title="Yeni Oda Ekle"
                                rel="tooltip" className="add-new">YENİ ODA EKLE</button>
                    </div>
                }*/}
                    <Modal isOpen={this.state.addChangeRequestModal} size="lg" className="ust">
                        <ModalHeader toggle={this.cancel}>{this.state.changeRequest && (this.state.changeRequest.processState === "NOT_PROCESSED") ? 'Üye Bilgi Değişikliği Talebi Onayla' : (this.state.changeRequest && this.state.changeRequest.processState === "APPROVED") ? 'Onaylanmış Değişiklik Talebi (Değişen Alanlar)' : 'Reddedilmiş Değişiklik Talebi (Değişiklik Talep Edilen Alanlar)' }</ModalHeader>
                        <ModalBody>
                            <MemberGeneralInfo saveUser={this.save}
                                               cancelProcess={this.cancel}
                                               selectedChangeRequest={this.state.changeRequest}
                                               mode={this.state.mode}
                                               currentUser={this.props.currentUser}
                                               handleSearch={this.handleSearch}/>
                        </ModalBody>
                    </Modal>
                </div>
            </div>
        )
    }
}

export default ChangeRequestList;


// WEBPACK FOOTER //
// ./src/page/changeRequest/ChangeRequestList.js